/*
  Plays popup video which has a youtube/vimeo link
*/

export function videoPopupPlayerLink() {
  // var videoSrc;
  // var videoControls;
  // $('.video-iframe-thumbnail.video-url').click(function () {
  //   videoSrc = $(this).data('src');
  //   videoControls = $(this).data('controls');
  // });

  // $('#myModal-video-url.video-url').on('shown.bs.modal', function () {
  //   $('#myModal-video-url #video').attr(
  //     'src',
  //     videoSrc + '?autoplay=1&muted=1&mute=1&modestbranding=1&'+ videoControls+'&showinfo=0;'
  //   );
  // });

  // $('#myModal-video-url').on('hide.bs.modal', function () {
  //   $('#myModal-video-url #video').attr('src', '');
  // });

 $('.video-section.v2.link').each(function(index) {
    const modal = $(this).find('.modal');
    let videoOverlay = $(this).find('.video-overlay');

    const modalId = 'myModal-video-url-' + index;
    modal.attr('id', modalId);
    videoOverlay.attr('data-target', '#' + modalId);

    var video;
    var videoControls;

    videoOverlay.on('click', function() {
      video = $(this).siblings('.video-thumb').data('src');
      videoControls = $(this).siblings('.video-thumb').data('controls') || '';
    });

    modal.on('shown.bs.modal', function () {
      if (video) {
        modal.find('iframe').attr(
          'src',
          video + '?autoplay=1&muted=1&modestbranding=1&' + videoControls + '&showinfo=0'
        );
      }
    });

    modal.on('hide.bs.modal', function () {
      modal.find('iframe').attr('src', '');
    });
  });
}